import { Link } from '~/components/link';
import { routes } from '~/config/routes';

export const LegalNotice = () => {
  return (
    <p className="mt-6 text-center text-sm text-slateGray">
      By Signing Up you agree with{' '}
      <Link href={routes.legal.terms}>
        <a className="underline" target="_blank" rel="noopener noreferrer">
          Terms of Service Agreement
        </a>
      </Link>
    </p>
  );
};
